import axios from 'axios'

/**
 * Get headers with an Authorization token for making HTTP requests.
 *
 * @returns {Headers} - The headers object with the Authorization token.
 */
export const getHeaders = (): Headers => {
  const myHeaders = new Headers()
  return myHeaders
}

/**
 * Removes user information from session storage.
 */
export const removeUser = async () => {
  const data = await axios.post(`/self/api/logout`)
  return data
}
